

import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ProfileFormValues } from '../ProfileFormSchema';

interface TrainingPreferenceFieldProps {
  control: Control<ProfileFormValues>;
}

export function TrainingPreferenceField({ control }: TrainingPreferenceFieldProps) {
  return (
    <FormField
      control={control}
      name="training_preference"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Training Preference</FormLabel>
          <FormControl>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value || 'Both'}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select training preference" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Gi">Gi</SelectItem>
                <SelectItem value="No-gi">No-gi</SelectItem>
                <SelectItem value="Both">Both</SelectItem>
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
